/* Phase 30 — full-page backdrops. One fallback chain so no page ever renders an empty band. */
import { useEffect } from "react";
import { matchPath } from "react-router-dom";

export const IMG = {
  hero: "/images/hero.webp", dates: "/images/khalas.webp", souq: "/images/sukkari.webp", story: "/images/story-harvest.webp",
  heritage: "/images/story-alahsa-unesco.webp", route: "/images/story-darb-zubaidah.webp", dish: "/images/hinney.webp",
  madinah: "/images/city-madinah.webp", alula: "/images/city-alula.webp", bisha: "/images/city-bisha.webp",
};

/* Route → default backdrop. [pattern, image, tone] — tone: "soft" (content pages) | "deep" (app/dashboards) | "none" */
const ROUTE_BG = [
  ["/", IMG.hero, "home"],
  ["/map", null, "none"],
  ["/admin/*", null, "none"], ["/admin", null, "none"],
  ["/knowledge", IMG.heritage, "soft"],
  ["/provenance", IMG.dates, "soft"],
  ["/provenance/dashboard", IMG.dates, "deep"],
  ["/dashboard", IMG.heritage, "deep"],
  ["/trader/dashboard", IMG.souq, "deep"],
  ["/souq/dashboard", IMG.souq, "deep"],
  ["/souq/payment/callback", IMG.souq, "deep"],
  ["/auth", IMG.madinah, "deep"], ["/auth/*", IMG.madinah, "deep"], ["/provenance/auth", IMG.madinah, "deep"], ["/souq/auth", IMG.madinah, "deep"],
  ["/verify/*", IMG.dates, "deep"],
  ["/souq", IMG.souq, "soft"], ["/souq/listing/*", IMG.souq, "soft"],
  ["/regions", IMG.alula, "soft"], ["/regions/*", IMG.alula, "soft"],
  ["/varieties", IMG.dates, "soft"], ["/varieties/directory", IMG.dates, "soft"], ["/varieties/*", IMG.dates, "soft"],
  ["/oases", IMG.heritage, "soft"], ["/oases/*", IMG.heritage, "soft"],
  ["/routes", IMG.route, "soft"], ["/routes/*", IMG.route, "soft"],
  ["/stories", IMG.story, "soft"], ["/stories/*", IMG.story, "soft"],
  ["/culinary", IMG.dish, "soft"], ["/culinary/*", IMG.dish, "soft"],
  ["/gallery", IMG.heritage, "soft"],
  ["/contact", IMG.bisha, "soft"], ["/terms", IMG.heritage, "soft"], ["/privacy", IMG.heritage, "soft"], ["/dmca", IMG.heritage, "soft"],
];

export function routeBackdrop(pathname) {
  const hit = ROUTE_BG.find(([p]) => matchPath({ path: p, end: true }, pathname));
  return hit ? { image: hit[1], tone: hit[2] } : { image: IMG.route, tone: "deep" }; // 404 → trade-route dusk
}

/* First usable candidate wins; blank/undefined skipped. */
export const pickImage = (...candidates) => candidates.find((c) => typeof c === "string" && c.trim()) || IMG.hero;

/* Pages with their own imagery push it to the global backdrop (cleared on unmount → route default). */
const listeners = new Set();
let override = null;
export const subscribeBackdrop = (fn) => { listeners.add(fn); fn(override); return () => listeners.delete(fn); };
const emit = (v) => { override = v; listeners.forEach((fn) => fn(v)); };
export function useBackdrop(image) {
  useEffect(() => {
    if (!image) return undefined;
    emit(image);
    return () => emit(null);
  }, [image]);
}
